import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API });

api.interceptors.request.use((config) => {
    const token = localStorage.getItem("sudigi_token");
    if (token) config.headers.Authorization = `Bearer ${token}`;
    return config;
});

export function captureUTM() {
    try {
        const params = new URLSearchParams(window.location.search);
        const existing = JSON.parse(localStorage.getItem("sudigi_utm") || "null");
        const src = params.get("utm_source");
        if (src || !existing) {
            const utm = {
                source: src || (document.referrer ? "referral" : "direct"),
                medium: params.get("utm_medium") || null,
                campaign: params.get("utm_campaign") || null,
                landing_page: window.location.pathname,
                referrer: document.referrer || null,
            };
            if (src || !existing) localStorage.setItem("sudigi_utm", JSON.stringify(utm));
        }
    } catch (e) { /* noop */ }
}

export function getUTM() {
    try {
        return JSON.parse(localStorage.getItem("sudigi_utm") || "null") || { source: "direct" };
    } catch (e) {
        return { source: "direct" };
    }
}

export function formatApiError(detail) {
    if (detail == null) return "Something went wrong. Please try again.";
    if (typeof detail === "string") return detail;
    if (Array.isArray(detail)) return detail.map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e))).join(" ");
    if (detail && typeof detail.msg === "string") return detail.msg;
    return String(detail);
}

export const inr = (n) => "₹" + Number(n || 0).toLocaleString("en-IN");

export const track = (event, data = {}) => {
    try {
        if (window.dataLayer) window.dataLayer.push({ event, ...data });
        if (window.posthog) window.posthog.capture(event, data);
    } catch (e) { /* noop */ }
};
